<template>
  <StandardLayout header="Anpassungen">
    <template v-slot:main>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="h5">Letzte Anpassungen</div>
          <AdjustmentList :adjustments="adjustments"/>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-header">Neue Anpassung</div>
            <div class="card-body">
              <AdjustmentEditor v-model="newAdjustment"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </StandardLayout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import AdjustmentList from "@/components/controlling/adjustments/AdjustmentList";
import AdjustmentEditor from "@/components/controlling/adjustments/AdjustmentEditor";

const defaultAdjustment = {
  title: '',
  value: 0.0,
  kpi: 'netIncome'
}

export default {
  components: {AdjustmentEditor, AdjustmentList, StandardLayout},
  data() {
    return {
      adjustments: [],
      newAdjustment: defaultAdjustment
    }
  },
  methods: {
    loadAdjustments() {
      this.$api.get('/adjustments/net-income')
          .then(response => this.adjustments = response.data)
          .catch(error => this.handleError(error))
    },
    postNewAdjustment() {
      this.$api.post('/adjustments', this.newAdjustment)
          .then(() => {
            this.showInfo("Anpassung gespeichert")
            this.reset()
          }).catch(error => this.handleError(error))
    },
    reset(){
      this.newAdjustment = defaultAdjustment
      this.loadAdjustments()
    }
  },
  watch: {
    newAdjustment(newValue) {
      if (newValue.value !== 0)
        this.postNewAdjustment()
    }
  },
  mounted() {
    this.loadAdjustments()
  }
}
</script>
